import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/home/global'

export const HOME_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
